import { Box, Avatar, Icon, TypeIconName, BoxProps } from '@bitrise/bitkit';

type BadgedAvatarProps = {
  badgeIconName: TypeIconName;
  name: string;
  src?: string;
  variant?: 'letters' | 'project';
  size?: '40' | '48';
} & BoxProps;

const BadgedAvatar = ({ name, src, badgeIconName, variant = 'letters', size = '48', ...rest }: BadgedAvatarProps) => (
  <Box alignItems="center" display="flex" height="3.5rem" position="relative" {...rest}>
    <Avatar name={name} src={src} variant={variant} size={size} />
    <Box
      backgroundColor="background/primary"
      borderRadius="50%"
      bottom="-2"
      boxShadow="0rem 0.125rem 0.25rem rgba(0, 0, 0, 0.06)"
      height="1.5rem"
      padding="4"
      position="absolute"
      right="-8"
      width="24"
    >
      <Icon name={badgeIconName} color="icon/secondary" size="16" verticalAlign="top" />
    </Box>
  </Box>
);

export default BadgedAvatar;
